module.exports = __webpack_public_path__ + "674a8a3ee7290e710a22885dd8efda00.pdf";